import ExportPrototypeModulesListRequestModel from '../../../generated/types/model/request/ExportPrototypeModulesListRequestModel';

export default class ExportPrototypeModulesListRequestViewModel extends ExportPrototypeModulesListRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
